import React, { useState } from 'react';
import '../styles/feedbackFrorm.css';
import axios from 'axios';

const FeedbackForm = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    question1: '',
    question2: '',
    question3: '',
    optional: ''
 });

  const [showThankYou, setShowThankYou] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_BACKEND_APP_URL}/api/feedbacks`, formData);
      console.log('Feedback response:', response.data);
      setFormData({ question1: '', question2: '', question3: '', optional: '' });
      setShowThankYou(true); 
      setTimeout(() => {
        setShowThankYou(false); 
        onClose();
      }, 3000);
    } catch (error) {
      console.error('Error submitting feedback:', error);
    }
  };

  const handleTextareaChange = (e) => {
    const text = e.target.value;
    if (text.length <= 100) {
      setFormData({ ...formData, optional: text });
    }
  };

  if (!isOpen && !showThankYou) return null;

  return (
    <div className="feedback-overlay">
      {showThankYou ? (
        <div className="thank-you-modal">
          <p>Thank you for your valuble feedback.</p>
        </div>
      ) : (
        <div className="feedback-modal">
          <div className="feedback-header">
            <h2 className="feedback-title">Give us your feedback</h2>
            <button className="close-button" onClick={onClose}>✕</button>
          </div>

          <form onSubmit={handleSubmit} className="feedback-form">
            <div className="form-group">
              <label className="form-label">How do you rate the IFRS Knowledge Bot experience?</label>
              <select
                className="form-select"
                value={formData.question1}
                onChange={(e) => setFormData({ ...formData, question1: e.target.value })}
                required
              >
                <option value="">Select an option</option>
                <option value="option3">Satisfied</option>
                <option value="option2">Neither satisfied nor dissatisfied</option>
                <option value="option1">Dissatisfied</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Would you recommend the IFRS Knowledge Bot to another person?</label>
              <select
                className="form-select"
                value={formData.question2}
                onChange={(e) => setFormData({ ...formData, question2: e.target.value })}
                required
              >
                <option value="">Select an option</option>
                <option value="option1">Yes</option>
                <option value="option2">No</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">Are there any specific areas you would like the IFRS Knowledge Bot to improve on?</label>
              <select
                className="form-select"
                value={formData.question3}
                onChange={(e) => setFormData({ ...formData, question3: e.target.value })}
                required
              >
                <option value="">Select an option</option>
                <option value="option1">Yes</option>
                <option value="option2">No</option>
              </select>
            </div>

            <div className="form-group">
              <label className="form-label">If yes, what would that be?</label>
              <div className="textarea-container">
                <textarea
                  className="form-textarea"
                  value={formData.optional}
                  onChange={handleTextareaChange}
                  placeholder="Type here...."
                  maxLength={100}
                />
                <div className="char-counter">
                  {formData.optional.length}/100
                </div>
              </div>
            </div>

            <div className="submit-container">
              <button type="submit" className="submit-button">
                Submit
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default FeedbackForm;